<template>
  <div class="cropper-content">
    <div class="cropper-box">
      <div class="cropper">
        <vue-cropper
            ref="cropper"
            :img="option.img"
            :outputSize="option.outputSize"
            :outputType="option.outputType"
            :info="option.info"
            :canScale="option.canScale"
            :autoCrop="option.autoCrop"
            :autoCropWidth="option.autoCropWidth"
            :autoCropHeight="option.autoCropHeight"
            :fixed="option.fixed"
            :fixedNumber="option.fixedNumber"
            :full="option.full"
            :fixedBox="option.fixedBox"
            :canMove="option.canMove"
            :canMoveBox="option.canMoveBox"
            :original="option.original"
            :centerBox="option.centerBox"
            :height="option.height"
            :infoTrue="option.infoTrue"
            :maxImgSize="option.maxImgSize"
            :enlarge="option.enlarge"
            :mode="option.mode"
            @realTime="realTime"
            @imgLoad="imgLoad">
        </vue-cropper>
      </div>
      <!--底部操作工具按钮-->
      <div class="footer-btn">
        <div class="scope-btn">
          <label class="btn" for="uploads">选择头像</label>
          <input type="file" id="uploads" style="position:absolute; clip:rect(0 0 0 0);" accept="image/png, image/jpeg, image/gif, image/jpg" @change="selectImg($event)">
          <el-button size="mini" type="danger" plain icon="el-icon-zoom-in" @click="changeScale(1)">放大</el-button>
          <el-button size="mini" type="danger" plain icon="el-icon-zoom-out" @click="changeScale(-1)">缩小</el-button>
          <el-button size="mini" type="danger" plain @click="rotateLeft">↺ 左旋转</el-button>
          <el-button size="mini" type="danger" plain @click="rotateRight">↻ 右旋转</el-button>
        </div>
        <div class="upload-btn">
          <el-button size="mini" :loading="btnLoading" type="success" @click="uploadImg('blob')">上传头像 <i class="el-icon-upload"></i></el-button>
        </div>
      </div>
    </div>
    <!--预览效果图-->
    <div class="show-preview">
      <div :style="previews.div" class="preview">
        <img :src="previews.url" :style="previews.img">
      </div>
    </div>
  </div>
</template>

<script>
import { VueCropper } from 'vue-cropper'
import lrz from 'lrz'
import axios from 'axios'
import api from '../api/index.js'
export default {
  name: 'CropperImage',
  components: {
    VueCropper
  },
  props: [ 'Name', 'type' ],
  data() {
    return {
      btnLoading: false,
      name: this.Name,
      photoBase64: '',
      previews: {},
      headPhoto: {
        image: '',
        status: 0
      },
      option: {
        img: '', // 裁剪图片的地址
        outputSize: 1, // 裁剪生成图片的质量(可选0.1 - 1)
        outputType: 'jpeg', // 裁剪生成图片的格式（jpeg || png || webp）
        info: true, // 图片大小信息
        canScale: true, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 230, // 默认生成截图框宽度
        autoCropHeight: 150, // 默认生成截图框高度
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [3.55, 5], // 截图框的宽高比例
        full: false, // false按原比例裁切图片，不失真
        fixedBox: true, // 固定截图框大小，不允许改变
        canMove: false, // 上传图片是否可以移动
        canMoveBox: true, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: false, // 截图框是否被限制在图片里面
        height: true, // 是否按照设备的dpr 输出等比例图片
        infoTrue: false, // true为展示真实输出图片宽高，false展示看到的截图框宽高
        maxImgSize: 3000, // 限制图片最大宽度和高度
        enlarge: 1, // 图片根据截图框输出比例倍数
        mode: '230px 150px' // 图片默认渲染方式
      }
    };
  },
  methods: {
    // 初始化函数
    imgLoad (msg) {
      console.log('工具初始化函数=====' + msg)
    },
    // 图片缩放
    changeScale (num) {
      num = num || 1
      this.$refs.cropper.changeScale(num)
    },
    // 向左旋转
    rotateLeft () {
      this.$refs.cropper.rotateLeft()
    },
    // 向右旋转
    rotateRight () {
      this.$refs.cropper.rotateRight()
    },
    // 实时预览函数
    realTime (data) {
      this.previews = data
    },
    // 选择图片
    selectImg (e) {
      let file = e.target.files[0]
      if (!/\.(jpg|jpeg|png|JPG|PNG)$/.test(e.target.value)) {
        this.$message({
          message: '图片类型要求：jpeg、jpg、png',
          type: 'error'
        });
        return false
      }
      // 压缩、转base64 upData
      let _this = this
      lrz(file)
        .then(function (rst) {
          // success process run
          _this.photoBase64 = rst.base64
          // 清空file内容
          e.value = '';
        })
        .catch(function () {
          // 处理失败会执行
          return false;
        })
        .always(() => {
          // 不管是成功失败，都会执行
          return false;
        });
      // 转化为blob
      let reader = new FileReader()
      reader.onload = (e) => {
        let data
        if (typeof e.target.result === 'object') {
          data = window.URL.createObjectURL(new Blob([e.target.result]))
        } else {
          data = e.target.result
        }
        this.option.img = data
      }
      // 转化为base64
      reader.readAsDataURL(file)
    },
    // 上传图片
    uploadImg (type) {
      this.$refs.cropper.getCropData((data) => {
        // do something
        // console.log(data, 'ggg')
        let imgData = new FormData();
        imgData.append('UserName', 'qiuwenyan@eastfair.com');
        imgData.append('UserPwd', 'lkj13*ksjd$kjkj');
        imgData.append('ProjectType', 'Ezt');
        imgData.append('Project', 'fzz');
        imgData.append('PicType', 'avatar');
        imgData.append('ExhID', sessionStorage.getItem('ExhID'));
        imgData.append('Base64Img', data.split(',')[1]);
        // 百度接口
        let url = 'https://std.eastfair.com/Faceai/api/Face/FaceDetect';
        this.btnLoading = true
        axios({
          method: 'POST',
          url: url,
          cache: false,
          processData: false,
          contentType: false,
          data: imgData
        }).then(res => {
          if(sessionStorage.getItem('isFaceRepat') && sessionStorage.getItem('isFaceRepat') === 'true') { // 头像查重
            let PersonID = res.data.PersonID; // 如果为注册过得头像，那么PersonID不为空，否则为空
            let PsnCardNo = sessionStorage.getItem('PsnCardNo'); // 成功页存储的卡号
            // let PsjFlag = sessionStorage.getItem('PsjFlag');
            if(!PsnCardNo) { // 如果没有注册过
              if (res.data.PersonNum > 0) { // 如果头像重复
                this.$alert('人脸已注册，请重新上传！', '错误信息', {
                  confirmButtonText: '确定',
                  closeOnClickModal: true,
                  type: 'error'
                });
                this.btnLoading = false
                return false;
              } else {
                this.headDataSave(imgData, res.data);
                return true;
              }
            } else { // 如果已经注册过
              if(PersonID === '' || PersonID === null || PersonID === undefined) {
                if (res.data.PersonNum > 0) { // 如果头像重复
                  this.loading = false;
                  this.$alert('人脸已注册，请重新上传！', '错误信息', {
                    confirmButtonText: '确定',
                    closeOnClickModal: true,
                    type: 'error'
                  });
                  this.btnLoading = false
                  return false;
                } else {
                  this.headDataSave(imgData, res.data);
                  return true;
                }
              } else {
                if(PsnCardNo === PersonID) { // 如果为操作本人头像，允许修改头像
                  this.headDataSave(imgData, res.data);
                  return true;
                } else { // 如果不是本人操作，不允许修改头像
                  this.$alert('请确定上传本人头像', '错误信息', {
                    confirmButtonText: '确定',
                    closeOnClickModal: true,
                    type: 'error'
                  });
                  this.btnLoading = false
                  return false;
                }
              }
            }
          } else { // 如果头像不查重
            if (res.data.PersonNum > 0) {
              this.$confirm('人脸已注册, 是否继续?', '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                this.headDataSave(imgData, res.data);
                return true;
              }).catch(() => {
                this.FaceID = '';
                this.btnLoading = false
                return false;
              });
            } else {
              this.headDataSave(imgData, res.data);
              return true;
            }
          }
        })
        .catch(() => {
          return false;
        })
      });
    },
    updateFace(photo) {
      api.updateFace({
        ExhID: sessionStorage.getItem('ExhID'),
        PsjID: sessionStorage.getItem('PsjID'),
        photo: photo,
        FaceID: this.FaceID
      }).then(res => {
        if (res.data.status === 'OK') {
          // 保存更新头像信息
          sessionStorage.setItem('headPhoto', JSON.stringify(this.headPhoto));
          // 保存上传的头像图片
          sessionStorage.setItem('PhotoUrl', res.data.message || '')
          this.$notify({
            title: '提示信息',
            message: '恭喜您，照片更新成功！',
            type: 'success'
          });
          this.btnLoading = false
        } else {
          this.$alert(res.data.ErrorMsg, '错误信息', {
            confirmButtonText: '确定',
            closeOnClickModal: true,
            type: 'error'
          });
          this.btnLoading = false
        }
      });
    },
    headDataSave(imgData, data) {
      this.FaceID = data.FaceID;
      // 将FaceID存储到$store中
      sessionStorage.setItem('FaceID', data.FaceID || '')
      if (data.status === 'OK') {
        axios({
          method: 'POST',
          url: 'https://std.eastfair.com/ImageServer/api/base64image/Upload',
          cache: false,
          processData: false,
          contentType: false,
          data: imgData
        }).then(res => {
          if (res.data.code === '0') {
            if(this.type && this.type === 'edit') {
              this.updateFace(res.data.message);
            } else {
              this.headPhoto.status = 1;
              this.headPhoto.image = res.data.message;
              // 保存上传头像信息
              sessionStorage.setItem('headPhoto', JSON.stringify(this.headPhoto));
              // 保存上传的头像图片
              sessionStorage.setItem('PhotoUrl', res.data.message || '')
              this.$emit('uploadImgSuccess', res.data.message)
              setTimeout(() => {
                this.btnLoading = false;
                this.hasGetPhoto = true;
                this.$notify({
                  title: '提示信息',
                  message: '恭喜您，照片上传成功！',
                  type: 'success'
                });
              }, 500);
            }
          }
        })
        .catch(() => {
          this.btnLoading = false;
          return false;
        })
      } else {
        this.btnLoading = false;
        this.$alert('请上传正面照片！', '错误信息', {
          confirmButtonText: '确定',
          closeOnClickModal: true,
          type: 'error'
        });
      }
    }
  }
}
</script>

<style scoped>
.cropper-content{
  display: flex;
  display: -webkit-flex;
  justify-content: flex-end;
}
.cropper-content .cropper-box{
  flex: 1;
  width: 100%;
}
.cropper-content .cropper-box .cropper{
  width: auto;
  height: 300px;
}
.cropper-content .show-preview{
  flex: 1;
  -webkit-flex: 1;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
}
.show-preview .preview{
  overflow: hidden;
  border:1px solid #67c23a;
  background: #cccccc;
}
.footer-btn{
  margin-top: 30px;
  display: flex;
  display: -webkit-flex;
  justify-content: flex-end;
}
.footer-btn .scope-btn{
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  padding-right: 10px;
}
.footer-btn .upload-btn{
  flex: 1;
  -webkit-flex: 1;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
}
.footer-btn .btn {
  outline: none;
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  -webkit-appearance: none;
  text-align: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  outline: 0;
  -webkit-transition: .1s;
  transition: .1s;
  font-weight: 500;
  padding: 8px 15px;
  font-size: 12px;
  border-radius: 3px;
  color: #fff;
  background-color: #409EFF;
  border-color: #409EFF;
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/CropperImage.vue